import React from 'react';
import { connect } from 'react-redux';
import { RibbonV2 } from '@americanexpress/aqx-components';
import { isCmCard, getCmCardBadgeText } from 'src/universal/redux/yourCardBadge';
import styles from './index.scss?modules';
import clsx from 'clsx';

const YourCardBadge = ({ cmText, renderBadge, isPdp, isPremium, isMobilePdp }) => {
  if (!(renderBadge && cmText)) return null;

  return (
    <RibbonV2
      type="sparrow-tail"
      size="md"
      className={clsx(
        styles.yourCardStyles,
        { [styles.pdpBadge]: isPdp },
        { [styles.premiumBadge]: isPremium },
        { [styles.mobilePdpBadge]: isMobilePdp }
      )}
    >
      {cmText}
    </RibbonV2>
  );
};

const mapStateToProps = () => {
  return (state, { shortName }) => ({
    cmText: getCmCardBadgeText(state),
    renderBadge: isCmCard(state, shortName)
  });
};

export default connect(mapStateToProps)(YourCardBadge);
